// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2fP6NgKu","terms":"_-qoyVhd"};